// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bd18384","239":"dd574731","453":"e5c43885","667":"405fb75f"}[chunkId] + ".chunk.js";
};